/*
Author: Vaishnavi
Date: 22/1//2019
Issue Description: Spacing issues fixed and upload image file component updated (line nos. 530 & 52)
*/

/*
Author: Vinod
Date: 03/12//2019
Issue Description: image deleting issue
search_string: deleteFile
*/

/*
Author: Srinivas P
Date: 06/12/2019
Issue Description: Changing the Save button label PL-2020
search_string: btnText
*/

/*
Author: Srinivas P
Date: 06/12/2019
Issue Description: After creating Organisation Created Successfully & After Updating Organisation Updated Successfully popup is required PL-2021
search_string: editMode
*/

/*
Author: Srinivas P
Date: 10/12/2019
Issue Description: Unable to Update Organisation with out State & city. PL-2276
search_string: editMode,removed the formTag
*/

/*
Author: Vinod
Date: 08/12/2019
Issue Description: When Org is created with same Name, Unable to get Error message in Front end.
search_string: PL_2381
*/

/*
Author: Vinod
Date: 10/03/2020
Issue Description: Uploaded logo is not displaying.
search_string: PL_2911
*/

/*
Author: Shivakumar
Date: 26/03/2020
Issue Description: [Organisation] While updating Organisation and Legal Entity Getting error message " parameter validation error
search_string: PL_2984
*/

<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>Organisation Information</div>
    </tl-header>
    <div class="row-container center margin-top-33" v-if="!showorgDetails">
      <div class="company-info">
        <img class="image" src="@/assets/orgInfo.svg" />
        <div class="margintop-10">
          <span class="help-text">
            Here you help us understand primary information about your organisation. It will give you customized experience
            of our offerings and make your onboarding easy and fast.
          </span>
          <div class="divider"></div>
          <btn text="Get Started" type="secondary" class="margintop-40" @click="getStarted" />
        </div>
      </div>
    </div>

    <div v-if="showorgDetails">
      <!-- Start PL_2381 -->
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <!-- End PL_2381 -->
      <div class="row upload-logo">
        <div class="col-12">
          <span class="input-label">Upload Company's Logo</span>
          <!-- start deleteFile -->
          <!-- PL_2911 -->
          <upload-image
            class="margintop-32"
            :logo="formData.logo"
            @deleteFile="formData.logo = ''"
            @change="(val) => formData.logo = val.data.location"
            @editImage="(val) => formData.logo = val.data.location"
          />
          <!-- end deleteFile -->
        </div>
      </div>
      <txt
        autofocus
        label="Corporation Id *"
        type="text"
        ref="corpId"
        name="corpId"
        v-validate="{required: true}"
        v-model="formData.code"
        data-vv-as="corporation id"
        :classname="errors.has('corpId')"
        :errormsg="errors.first('corpId')"
      />
      <txt
        autofocus
        label="Organisation / Brand Name *"
        type="text"
        ref="name"
        class="margintop-24"
        name="OrganisationName"
        data-vv-as="organisation / brand name"
        v-validate="{required: true, max: nameMaxlength}"
        v-model="formData.name"
        :classname="errors.has('OrganisationName')"
        :errormsg="errors.first('OrganisationName')"
      />

      <div class="head-office-text margintop-32">Head Office</div>

      <div class="row-items addflex margintop-24">
        <txt
          autofocus="autofocus"
          label="Address Line 1"
          type="text"
          v-model="formData.addressLineOne"
          name="addressLineOne"
          @change="(val)=>{formData.addressLineOne=val.trim()}"
          ref="addLineOne"
          data-vv-as="address line 1"
          v-validate="{required: false}"
          :classname="errors.has('addressLineOne')"
          :errormsg="errors.first('addressLineOne')"
        />
        <txt
          label="Address Line 2"
          type="text"
          v-model="formData.addressLineTwo"
          name="addressLineTwo"
          @change="(val)=>{formData.addressLineTwo=val.trim()}"
          ref="addLineTwo"
          data-vv-as="address line 2"
          v-validate="{required: false}"
          :classname="errors.has('addressLineTwo')"
          :errormsg="errors.first('addressLineTwo')"
        />
      </div>

      <div class="row-items addflex margintop-24">
        <tl-select
          class="customwidth"
          label="Country"
          labelText="name"
          name="headOfficeCountry"
          data-vv-as="country"
          :options="countriesList"
          :disable="true"
          v-model="formData.country"
          @change="(val)=>formData.country = val"
          v-validate="{required: true}"
          :classname="errors.has('headOfficeCountry')"
          :errormsg="errors.first('headOfficeCountry')"
        ></tl-select>
        <tl-select
          labelText="state_name"
          class="customwidth"
          name="State / Union Territory"
          :label="`State / Union Territory ${(formData.addressLineOne || formData.addressLineTwo) ? '*' : ''}`"
          :options="statesListData"
          v-model="formData.stateName"
          @change="(val)=>{formData.stateName=val;formData.cityName=''}"
          v-validate="{required: formData.addressLineOne || formData.addressLineTwo ? true: false}"
          :classname="errors.has('State / Union Territory')"
          :errormsg="errors.first('State / Union Territory')"
        ></tl-select>
      </div>
      <div class="row-items addflex margintop-24">
        <tl-select
          labelText="city_name"
          class="customwidth"
          :label="`City ${(formData.addressLineOne || formData.addressLineTwo) ? '*' : ''}`"
          name="city"
          v-model="formData.cityName"
          :disabled="(formData.stateName && formData.stateName.City.length) ? false:true"
          :options="formData.stateName ? formData.stateName.City:[]"
          @change="(val)=>formData.cityName=val"
          v-validate="{required: formData.addressLineOne || formData.addressLineTwo ? true : false}"
          :classname="errors.has('city')"
          :errormsg="errors.first('city')"
        ></tl-select>
        <txt
          name="pincode"
          :label="`Pincode ${(formData.addressLineOne || formData.addressLineTwo) ? '*' : ''}`"
          type="text"
          data-vv-as="pincode"
          v-model="formData.pincode"
          v-numeric-only
          v-validate="{required: (formData.addressLineOne || formData.addressLineTwo) ? true : false, regex:pincodeRegex}"
          :classname="errors.has('pincode')"
          :errormsg="errors.first('pincode')"
        />
      </div>
      <div class="row-items addflex margintop-24">
        <div>
          <txt
            label="Email Id"
            type="text"
            v-model="formData.orgEmail"
            name="orgEmail"
            data-vv-as="email"
          />
        </div>
        <div>
          <txt
            label="Phone Number *"
            type="text"
            data-vv-as="phone number"
            v-model="formData.phoneNumber"
            name="phonenumber"
            v-validate="{required: true,regex: phoneNumRegex}"
            :classname="errors.has('phonenumber')"
            :errormsg="errors.first('phonenumber')"
          />
        </div>
      </div>
      <toast-message :message="errmsg" v-show="toast" type="error" />
      <pop-up-message
        v-if="showSuccessMsg"
        :message="`${formData.name} has been successfully ${editMode ? 'Updated' : 'created. Proceed to the Organisation Summary page to add Legal Entities under it.'}`"
        btnText="Go To Org Summary"
        @back="backToSummary"
      ></pop-up-message>
      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="cancelOrgInfo" />
            <btn :text="submitBtnText" type="primary" @click="saveOrgInfo" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import * as config from "@/apis/config.js";
export default {
  components: {},
  data() {
    return {
      nameMaxlength: null,
      phoneNumRegex: null,
      emailRegex: null,
      pincodeRegex: null,
      editMode: false,
      submitBtnText: "Add New Organisation",
      showSuccessMsg: false,
      pdfPattern: "([a-zA-Z0-9s_\\.-:])+(.pdf)$",
      xlsPattern: "([a-zA-Z0-9s_\\.-:])+(.xls|.xlsx)$",
      imgPattern: "([a-zA-Z0-9s_\\.-:])+(.png|.jpg|.jpeg)$",
      errmsg: "",
      toast: false,
      showorgDetails: "",
      statesListData: [],
      countriesList: [],
      formData: {
        name: "",
        code: "",
        logo: "",
        pincode: null,
        stateName: null,
        cityName: null,
        addressLineOne: "",
        addressLineTwo: "",
        country: null,
        phoneNumber: "",
        orgEmail: ""
      }
    };
  },
  mounted() {
    this.btnText();
    this.setGlobalValidationsAndData();
  },

  activated() {
    this.btnText();
    this.getStatesData();
    this.showorgDetails = this.onboardingOrgId ? true : false;
  },
  computed: {
    ...mapState({
      email: state => state.auth.email,
      onboardingOrgId: state => state.onboard.organization.id,
      isFetching: state => state.onboard.organization.isFetching,
      isSaving: state => state.onboard.organization.isSaving,
      isDeleting: state => state.onboard.organization.isDeleting,
      globalData: state => state.globalapi.globalData.data
    }),

    isLoading() {
      return this.isFetching;
    }
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/organization/fetchAll",
      act_create: "onboard/organization/create",
      act_update: "onboard/organization/update",

      act_setOrgId: "onboard/organization/changeOrgId",
      act_SetAuthOrgId: "auth/changeTheNewOrg",
      act_setOrgType: "onboard/organization/changeOrgType"
    }),

    /** To set the various validations in form */
    setGlobalValidationsAndData(){
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.phoneNumRegex = config.Regex.PHONE_NUM;
        this.emailRegex = config.Regex.EMAIL;
        this.pincodeRegex = config.Regex.PINCODE;
        this.countriesList = config.GlobalList.countriesList;
        this.formData.country = this.countriesList[0]
          ? this.countriesList[0]
          : null;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    getStarted() {
      this.showorgDetails = true;
    },

    /** To fetch states data from store */
    async getStatesData() {
      try {
        this.statesListData = this.globalData ? this.globalData.State : [];
        this.getOrganisationData();
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** To set the various validations in form */
    async getOrganisationData() {
      try {
        if (this.onboardingOrgId) {
          //console.log('orgInfo.vue',this.onboardingOrgId)
          let res = await this.act_fetch(this.onboardingOrgId);
          if (res.data.status) {
            this.formData["name"] = res.data.payload.data[0].name;
            this.formData["code"] = res.data.payload.data[0].code;
            this.formData["addressLineOne"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.addressLineOne
              : "";
            this.formData["addressLineTwo"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.addressLineTwo
              : "";
            this.formData["pincode"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.pincode
              : null;
            this.formData["stateName"] = this.setStateObj(
              res.data.payload.data[0].headOfficeAddress
                ? res.data.payload.data[0].headOfficeAddress.stateID
                : ""
            );
            this.formData["cityName"] = this.setCityObj(
              res.data.payload.data[0].headOfficeAddress.cityID
            );
            this.formData["country"] = this.setCountryObj();
            this.formData["orgEmail"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.email
              : "";
            this.formData["phoneNumber"] = res.data.payload.data[0]
              .headOfficeAddress
              ? res.data.payload.data[0].headOfficeAddress.phoneNumber
              : "";
            this.formData["logo"] = res.data.payload.data[0].logoURL;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Set State object from the store list */
    setStateObj(stateID) {
      try {
        if (stateID && this.statesListData.length) {
          return this.statesListData.find(res => res.id == stateID);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    //start of btnText change
    btnText() {
      this.editMode = this.onboardingOrgId ? true : false;
      this.submitBtnText = this.onboardingOrgId
        ? "Update"
        : "Add New Organisation";
    },
    //end of btnText change

    /** Set Country object from the store list */
    setCountryObj() {
      try {
        return this.countriesList[0] ? this.countriesList[0] : null;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Set City object from the store list */
    setCityObj(cityid) {
      try {
        if (cityid && this.formData.stateName) {
          return this.formData.stateName.City.find(res => res.id === cityid);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Navigation */
    backToSummary() {
      this.showSuccessMsg = false;
      this.resetForm();
      this.$router.push("/orgsummary");
    },

    /** Server call to create/update a organisation */
    async performAction() {
      try {
        let organisationID = this.onboardingOrgId;
        let requestApiObj = {
          name: this.formData.name.toString().trim(),
          code: this.formData.code,
          subscriptioType: "SAAS",
          logoURL: this.formData.logo,
          headOfficeAddress: {
            addressLineOne: this.formData.addressLineOne,
            addressLineTwo: this.formData.addressLineTwo,
            stateID: this.formData.stateName
              ? this.formData.stateName.id
              : null,
            cityID: this.formData.cityName ? this.formData.cityName.id : null,
            pincode: this.formData.pincode ? this.formData.pincode : null, //PL_2984
            email: this.formData.orgEmail ? this.formData.orgEmail : null,
            countryID: this.formData.country.id,
            phoneNumber: this.formData.phoneNumber.toString()
          }
        };
        this.$root._data.isSaving = true;
        let res = null;
        if (organisationID) {
          requestApiObj["id"] = organisationID;
          res = await this.act_update({
            data: {
              ...requestApiObj
            }
          });
        } else {
          res = await this.act_create({
            data: {
              ...requestApiObj
            },
            email: this.email
          });
        }
        if (res.data.status) {
          setTimeout(() => {
            if (!organisationID) {
              this.setOrgData(res.data.payload);
            }
            this.showSuccessMsg = true;
            this.$validator.reset();
            this.$root._data.isSaving = false;
          }, 500);
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** To set selected Organisation data in store */
    setOrgData(orgObj) {
      try {
        this.act_setOrgId(orgObj.id);
        this.act_SetAuthOrgId(orgObj.id);
        this.act_setOrgType(false);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    cancelOrgInfo() {
      this.$router.go(-1);
    },

    /** To set selected Organisation data in store */
    saveOrgInfo() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction().then(() => {});
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },

    /** Function to reset the form */
    resetForm() {
      try {
        this.formData = {
          name: "",
          code: "",
          logo: "",
          stateName: "",
          cityName: "",
          pincode: "",
          addressLineOne: "",
          addressLineTwo: ""
        };
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/components/margins.scss";

.errorr {
  border-color: #a41010;
}
.errorMessage {
  color: #e01717;
  .error {
    margin-top: 2px;
  }
}
.upload {
  width: 315px;
  display: flex;
  align-items: flex-end;
}

.upload {
  input[type="text"] {
    border-radius: 4px;
    border: 1px solid #37c6c0;
    padding: 10px;
    width: 123px;
    height: 54px;
    background-color: #ffffff;
    transition: ease-in-out, width 0.35s ease-in-out;

    &:focus {
      outline: none;
      border: 2px solid #37c6c0;
    }
  }
}

.help-text {
  width: 972px;
  height: 57px;
  font-family: $font-family;
  font-size: $font-size-l1;
  font-weight: 300;
  color: #404040;
}
.uploadalign {
  margin-top: -9px;
}
.margin-top-33 {
  margin-top: 17px;
}

.head-office-text {
  font-family: $font-family;
  font-size: $font-size-base;
  font-weight: 500;
  color: #000000;
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.upload-logo {
  margin-bottom: 24px;
}
.addflex {
  display: flex;
}
.customwidth {
  margin-right: 32px;
  width: 300px;
}
</style>
